module.exports = __webpack_public_path__ + "media/images/flags/MD-d2b929bf6d9be12a7a770fcd712f2f87.svg";